import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { GraduationCap } from "lucide-react";

export function LearnPage() {
  return (
    <div className="px-4 py-6 space-y-6">
      <div className="space-y-1">
        <h2 className="text-2xl font-bold tracking-tight">Lernbereich</h2>
        <p className="text-sm text-muted-foreground">
          Quiz und Karteikarten
        </p>
      </div>

      <Card className="border-dashed">
        <CardHeader>
          <div className="flex items-center gap-2">
            <GraduationCap className="h-5 w-5 text-vajra-cyan" />
            <CardTitle className="text-lg">Kommt bald</CardTitle>
          </div>
          <CardDescription>
            Der Lernbereich wird mit PROJ-6 implementiert. Hier findest du
            Quiz-Fragen und Karteikarten zu den Gelübden und Tugenden.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-lg bg-muted/50 p-8 text-center">
            <GraduationCap className="mx-auto h-12 w-12 text-muted-foreground/50" />
            <p className="mt-4 text-sm text-muted-foreground">
              Platzhalter fuer den Lernbereich
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
